import React, { useState } from 'react';

import { ThemeProvider, Button, Typography } from '@mui/material';
import './App.css'; // This defines the styles. See MyReactComponent.js for more info
import './BrandDesign.css'; //contains classes with Siemens colors for buttons and other interactive elements
import darkTheme from './theme';
import InteractiveVideo from './Components/interactive-video/index';
import AssociationExercise from './Components/AssociationExercise';
import { ChoiceExercise } from 'didactic-choice-exercise';


const App = () => {


    const onFinish = () => {
        return;
    }

    const Exercise1 = ({ onFinish }) => {

        const basicStyle = {
            cardRoot: {
                backgroundColor: '#333333'
            },
            optionSelected: {
                background: 'gray',
                color: 'white'
            },
            option: {
                width: '100%',
                fontSize: '18px',
                fontWeight: 500,
                textTransform: 'initial',
                padding: '7px 21px',
                border: '1px solid rgba(255, 255, 255, 0.23)',
                boxSizing: 'border-box',
                transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                borderRadius: '4px',
                cursor: 'pointer',
                color: '#fff'
            },
            selected: {
                background: 'gray',
                color: 'white'
            },
            correct: {
                background: 'green',
                color: 'white'
            },
            incorrect: {
                background: 'red',
                color: 'white'
            },
            button: {
                color: '#fff',
                margin: "10px",
                fontSize: '18px !important'
            },
            question: {
                color: '#fff',
                marginBottom: '20px'
            },
            feedback: {
                color: '#fff',
                marginTop: '20px'
            }

        };
        const nextBtn = (<Button className="bdo-button">Weiter</Button>);
        const checkAnswerBtn = (<Button className="bdo-button">Ok</Button>);

        const questions =
            [
                {
                    question: <div>
                        <Typography paragraph={true}><i>Wählen Sie aus, für welche Zwecke im Unternehmen eine relationale Datenbank gut geeignet ist, indem Sie alle korrekten Optionen markieren und anschließend auf „OK“ klicken.</i></Typography>
                    </div>,
                    isSingleChoice: false,
                    options: [
                        {
                            value: <Button>Schnelle Analyse von Social Media Feedback</Button>,
                            feedback: <Typography paragraph={true}></Typography>,
                            id: "q11",
                            isCorrect: false
                        },
                        {
                            value: <Button>Auflistung von Adressen</Button>,
                            feedback: <Typography paragraph={true}></Typography>,
                            id: "q12",
                            isCorrect: true
                        },
                        {
                            value: <Button>Übersicht über Ausgaben und Einnahmen</Button>,
                            feedback: <Typography paragraph={true}></Typography>,
                            id: "q13",
                            isCorrect: true
                        },
                        {
                            value: <Button>Parallele Bearbeitung von Datensätzen</Button>,
                            feedback: <Typography paragraph={true}></Typography>,
                            id: "q14",
                            isCorrect: false
                        }
                    ],
                    feedbackForCorrectAnswer: <Typography paragraph={true}>Das ist korrekt!</Typography>,
                    feedbackForInCorrectAnswer: <Typography paragraph={true}>Das ist leider nicht korrekt! Relationale Datenbanken sind für die Auflistung von Adressen und für die Übersicht über Ausgaben und Einnahmen gut geeignet.</Typography>,
                    feedbackForLessOptionsSelected: <Typography paragraph={true}>Das ist leider nicht korrekt! Relationale Datenbanken sind für die Auflistung von Adressen und für die Übersicht über Ausgaben und Einnahmen gut geeignet.</Typography>
                }
            ]

        const onFinishCE1 = () => {
            onFinish();
        }

        return (
            <div className='light-text'>
                <ChoiceExercise
                    exerciseQuestions={questions}
                    multipleAttempts={false}
                    isRetry={false}
                    showInstantFeedback={true}
                    isNext={true}
                    rowWiseOptions={false}
                    basicStyle={basicStyle}
                    nextBtn={nextBtn}
                    checkAnswerBtn={checkAnswerBtn}
                    onFinish={onFinishCE1}
                /></div>
        )

    }

    const Exercise2 = ({ onFinish }) => {

        const [showButton, setShowButton] = useState(false);

        const finishEx2 = () => {
            onFinish()
        }

        const theme = {
            listOnDrag: {
                backgroundColor: "rgb(255 255 255 / 20%)",
            },
            dropList: {
                display: "flex",
                flex: "1",
                width: "100%",
                borderRadius: "10px",
                border: "1px solid rgba(0, 0, 0, .05)",
                flexDirection: "column",
                marginBottom: "1.5rem",
            },
            card: {
                margin: ".2rem",
                backgroundColor: '#333333 !important',
                border: '2px solid #DF8639'
            },
            answerSpot: {
                padding: "50px",
                background: "rgb(255 255 255 / 20%)",
            },
        };
        const choices = [
            {
                id: "1",
                text: "Relationale Datenbänke",
            },
            {
                id: "2",
                text: "Big Data",
            },
            {
                id: "3",
                text: "Unstrukturierte Datensätze",
            },
            {
                id: "4",
                text: "Tabellen",
            },
            {
                id: "5",
                text: "Vermeidung von Redundanz"
            },
            {
                id: "6",
                text: "Festplattenspeicher"
            },
            {
                id: "7",
                text: "Daten kombinieren"
            },
            {
                id: "8",
                text: "Speicherung redundanter Daten"
            },
            {
                id: "9",
                text: "Strukturierte Daten"
            },
            {
                id: "10",
                text: "Sharding"
            },
        ];
        const dropList = [
            "SQL",
            "NoSQL",
        ];

        const calcResult = (result) => {
            if (result.correct) {
                setShowButton(true);
            }
        };

        return (
            <div className='light-text'>
                <Typography paragraph={true}>Ordnen Sie zu! SQL oder NoSQL? </Typography>
                <Typography paragraph={true}><i>Ziehen Sie mit der Maus die korrekten Elemente in die entsprechenden Kästen.</i></Typography>                   
                <AssociationExercise
                    dropList={dropList}
                    choiceList={choices}
                    theme={theme}
                    onFinish={calcResult}
                    buttonText={"Überprüfen"}
                />
                {showButton && <Button className='bdo-button' sx={{ml: '50px'}} onClick={finishEx2}>Weiter</Button>}
            </div>
        )
    }

    const markers = [{
        name: "0 - startMarker",
        markerStart: 0,
        pause: false
    },
    {
        name: "1 - Choice Exercise 1",
        markerStart: 36.5,
        pause: true,
        component: <Exercise1 onFinish={onFinish} />
    },
    {
        name: "2 - Drag and Drop Exercise",
        markerStart: 164.5,
        pause: true,
        component: <Exercise2 onFinish={onFinish} />
    },
    ];


    return (
        <ThemeProvider theme={darkTheme}>
            <InteractiveVideo markers={markers} videoSrc="2-5-2_COMP.mp4" muiTheme={darkTheme} number={0} />
        </ThemeProvider>
    )
}

export default App;